import { ListParamsT, ListUnshiftParamsT } from '@/core/types/list.types'

export const useList = () => {
    const loadList = async (params: ListParamsT) => {
        const { data_state, page, response } = params

        data_state.pagination.current_page = page

        try {
            data_state.is_loading = true

            data_state.list = response.data
            if (response.meta) data_state.pagination.total_pages = response.meta.last_page

            data_state.is_failed = false
            data_state.failure.error_state.is_cancel = false
        } catch (error) {
            data_state.failure.catchError(error)

            if (!data_state.failure.error_state.is_cancel) {
                data_state.is_failed = true
            }
        } finally {
            if (!data_state.failure.error_state.is_cancel) {
                data_state.is_loading = false
            }
        }
    }

    const loadListMore = async (params: ListParamsT) => {
        const { data_state, page, response } = params

        if (page > data_state.pagination.total_pages) return
        data_state.pagination.current_page = page

        try {
            data_state.is_loading = true

            data_state.list = data_state.list.concat(response.data)

            data_state.pagination.total_pages = response.meta.last_page

            data_state.is_failed = false
            data_state.failure.error_state.is_cancel = false
        } catch (error) {
            data_state.failure.catchError(error)

            if (!data_state.failure.error_state.is_cancel) {
                data_state.is_failed = true
            }
        } finally {
            if (!data_state.failure.error_state.is_cancel) {
                data_state.is_loading = false
            }
        }
    }

    return { loadList, loadListMore }
}
